import { FunctionComponent } from "react";

const EmptyBook: FunctionComponent = () => {
    return (
        <div>
            <p className="fst-italic fs-5">No Books Listed Here</p>
        </div>
    );
}
export default EmptyBook;